import storage from 'store'
import expirePlugin from 'store/plugins/expire'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import { getPlatformListAPI } from '@/api/userList'

storage.addPlugin(expirePlugin)
const user = {
  state: {
    token: '',
    name: storage.get('userName') || '',
    welcome: '',
    avatar: '',
    roles: [],
    info: storage.get('USER_INFO') || {},
    id: null,
    type: null,
    enabledPlatform: storage.get('enabledPlatform') || '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      // console.log('SET_TOKEN: (state, token)>>>', state, token)
      state.token = token
      storage.set(ACCESS_TOKEN, token, new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
    },
    SET_NAME: (state, { name, welcome }) => {
      // console.log('SET_NAME: (state, { name, welcome })>>>', state)
      state.name = name
      storage.set('userName', name)
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      storage.set('USER_INFO', info)
      state.info = info
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_TYPE: (state, type) => {
      state.type = type
    },
    SET_PLATFORM: (state, platform) => {
      state.enabledPlatform = platform
      storage.set('enabledPlatform', platform)
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            const result = response.result
            storage.set(ACCESS_TOKEN, result.data.token, new Date().getTime() + 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.data.token)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        // 请求后端获取用户信息 /api/user/info
        // getInfo()
        //   .then((response) => {
        //     const { result } = response.data
        //     if (result.role && result.role.permissions.length > 0) {
        //       const role = { ...result.role }
        //       role.permissions = result.role.permissions.map((permission) => {
        //         const per = {
        //           ...permission,
        //           actionList: (permission.actionEntitySet || {}).map((item) => item.action),
        //         }
        //         return per
        //       })
        //       role.permissionList = role.permissions.map((permission) => {
        //         return permission.permissionId
        //       })
        // 覆盖响应体的 role, 供下游使用
        // result.role = role
        // console.log(role,'ssssssssssssssss')
        // commit('SET_ROLES', ['admin'])
        // commit('SET_INFO', result)
        // commit('SET_NAME', { name: result.name, welcome: welcome() })
        // commit('SET_AVATAR', result.avatar)
        // 下游
        resolve()
        //   } else {
        //     reject(new Error('getInfo: roles must be a non-null array !'))
        //   }
        // })
        // .catch((error) => {
        //   reject(error)
        // })
      })
    },
    GetPlatformList({ commit }) {
      getPlatformListAPI().then((res) => {
        commit('SET_PLATFORM', res.data)
      })
    },
    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.name)
          .then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            storage.remove(ACCESS_TOKEN)
            resolve()
          })
          .catch((err) => {
            console.log('logout fail:', err)
            // resolve()
          })
          .finally(() => {})
      }) // hxn
      /* commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      storage.remove(ACCESS_TOKEN) */
    },
  },
}

export default user
